export default __webpack_public_path__ + "static/media/consumer.230e94da.png";